import React, { useEffect, useState } from 'react'
import { FaTruck } from 'react-icons/fa'
import { BiRightArrowAlt } from 'react-icons/bi'
import { HiOutlinePlusSm } from 'react-icons/hi'
import AddShipRateModal from '../AddShipRateModal/AddShipRateModal'
import { useNavigate } from 'react-router-dom'

const ProductsShipRates = () => {
    const [addRate, setAddRate] = useState(false)
    const [data, setData] = useState('table')

    const navigate = useNavigate()

    const handleAddShipRate = () => {
        setAddRate(true)
    }

    const handleNavDetail = () => {
        navigate('/product/shipping-rate/123')
    }

    useEffect(() => {
        setData(data)
    }, [data])

    return (
        <>
            <div>
                {data ?
                    <div className='w-full mt-5'>
                        <div className='w-full overflow-x-auto'>
                            <table className='table-auto product-table md:w-full w-[730px] overflow-x-auto'>
                                <thead>
                                    <tr className='border-b-[1px] border-[#ebeef1] text-[#1a1b25]'>
                                        <th className='text-[11px] px-[12px] py-[8px] font-medium text-start'>ID</th>
                                        <th className='text-[11px] px-[12px] py-[8px] font-medium text-start'>DESCRIPTION</th>
                                        <th className='text-[11px] px-[12px] py-[8px] font-medium text-start'>AMOUNT</th>
                                        <th className='text-[11px] px-[12px] py-[8px] font-medium text-start'>STATUS</th>
                                        <th className='text-[11px] px-[12px] py-[8px] font-medium text-start'>CREATED</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className='border-b-[1px] border-[#ebeef1] hover:bg-[#f6f8fa] text-[#1a1b25]' onClick={handleNavDetail}>
                                        <td className='px-[12px] py-[8px] text-[13px] cursor-pointer' >shr_1NL0D4SH60np6AHNO6Xgnt9S</td>
                                        <td className='px-[12px] py-[8px] text-sm cursor-pointer'>test</td>
                                        <td className='px-[12px] py-[8px] text-sm cursor-pointer font-semibold'>$100.00 USD</td>
                                        <td className='px-[12px] py-[8px] text-sm cursor-pointer'>
                                            <div className='text-[#006908] bg-[#d7f7c2] p-[1px_6px] text-xs rounded-sm w-max font-medium'>Active</div>
                                        </td>
                                        <td className='px-[12px] py-[8px] text-sm cursor-pointer'>6/20/23, 2:16 PM</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="flex justify-between items-center mt-2">
                            <span className="text-[#687385] text-sm"><b>1</b> results</span>
                            <div className="flex gap-2">
                                <button className="border-[2px] h-[28px] rounded-[6px] border-[#ebeef1] text-[12px] font-semibold p-[0_8px] opacity-60">Previous</button>
                                <button className="border-[2px] h-[28px] rounded-[6px] border-[#ebeef1] text-[12px] font-semibold p-[0_8px] opacity-60" disabled="">Next</button>
                            </div>
                        </div>
                    </div> :
                    <div className='h-[564px] flex items-center justify-center'>
                        <div className="p-[64px]">
                            <div className='p-[12px] w-max rounded-[8px] bg-[#f6f8fa]'>
                                <FaTruck className="fill-gray-500 text-[25px]" />
                            </div>
                            <div className="mt-6">
                                <span className="text-[20px] font-bold text-[#1a1b25]">Add your first test shipping rate</span>
                            </div>
                            <p className="text-sm text-[#687385] max-w-[389px] flex-wrap mt-1">Specify shipping rates and use it on your customers’ receipts, invoices, and Checkout Sessions.</p>
                            <button className="text-[#625afa] mt-1 flex items-center font-medium gap-1 text-sm">
                                Learn more
                                <BiRightArrowAlt className='text-[20px] translate-y-[2px]' />
                            </button>
                            <button onClick={handleAddShipRate} className="flex gap-1 mt-5 text-white font-semibold h-[30px] bg-[#635bff] rounded-[6px] text-[14px] items-center p-[4px_8px]"><HiOutlinePlusSm className="text-[22px]" />Create shipping rate</button>
                        </div>
                    </div>
                }
            </div>
            <AddShipRateModal addRate={addRate} setAddRate={setAddRate} />
        </>
    )
}

export default ProductsShipRates